/**
 * Generates a valid MongoDB-compatible ObjectId string on the client side.
 *
 * Follows the official ObjectId spec (https://www.mongodb.com/docs/manual/reference/bson-types/#objectid):
 *   - 4 bytes: Unix timestamp in seconds
 *   - 5 bytes: Random value (generated once per session)
 *   - 3 bytes: Incrementing counter (initialized to a random value)
 *
 * Total: 12 bytes = 24 hex characters.
 */
// Per-session random value (5 bytes = 10 hex chars), generated once
const PROCESS_RANDOM = Array.from({ length: 10 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
// Counter initialized to a random value, increments per call (wraps at 0xFFFFFF)
let counter = Math.floor(Math.random() * 0xffffff);

export function generateObjectId(): string {
  const timestamp = Math.floor(Date.now() / 1000)
    .toString(16)
    .padStart(8, '0');
  const count = (counter++ & 0xffffff).toString(16).padStart(6, '0');
  return timestamp + PROCESS_RANDOM + count;
}
